import React, { Component } from "react";
import { Breadcrumb } from "react-bootstrap";
import { connect } from "react-redux";
import Moment from "react-moment";
import Spinner from "react-bootstrap/Spinner";
import { FormGroup, Input } from "reactstrap";
import Dropzone from "react-dropzone";
import {
  MdOutlineCheck,
  MdOutlineChevronLeft,
  MdOutlineClose,
} from "react-icons/md";
import { FaTrashAlt, FaRegEdit } from "react-icons/fa";
import { BsSave } from "react-icons/bs";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

class approvedView extends Component {
  constructor(props) {
    super(props);
    let encryptedId = this.props.location.search;
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );
    var Referenceno = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.state = {
      file: null,
      downloadData: undefined,
      isFunctionCalled: false,
      isModalOpen: false,
      referenceNo: Referenceno,
      loading: "",
      remarks: "",
      requesterId: 0,
      approverComments: "",
      typeOfExit: 0,
      typeOfExitName: "",
      dateJoined: "",
      approverSection: "",
      lastDayofService: "",
      phoneNumber: "",
      address: "",
      actionCategory: "",
      companycode: "",
      companyName: "",
      divisionName: "",
      divisioncode: "",
      actionType: 0,
      employeeId: "",
      employeeName: "",
      eDocType: "",
      startDate: "",
      endDate: "",
      positionId: "",
      salaryGrade: "",
      workingGroup: "",
      additionalInformation: "",
      description: "",
      userId: this.props.UserId,
      section: "",
      division: "",
      department: "",
      designation: "",
      requesterName: "",
      referenceLinkList: [
        {
          reflink: "",
          remarks: "",
        },
      ],
      attachmentList: [
        {
          referenceNo: "",
          filename: "",
          filetype: "",
          remarks: "",
          userId: 0,
        },
      ],
      empLastDayService: "",
      noticePeriodtoServe: 0,
      noticePeriodtoLieu: 0,
      annualLeaveBal: 0,
      exitInterview: "",
      employmentPass: "",
      ePass: "",
      medicalCard: "",
      hrRemarks: "",
      files: "",
      documents: "",
      fixedAsset: "",
      cash: "",
      locker: "",
      keys: "",
      managerRemarks: "",
      exceedMC: 0,
      exceedMedEnt: "",
      motorVehicleLoan: "",
      motorVehicleRemarks: "",
      trainingBond: "",
      coEremarks: "",
      staffAdvOutstand: "",
      financeRemarks: "",
      ictUserID: "",
      ictUserIDRemarks: "",
      ictAsset: "",
      ictAssetRemarks: "",
      ppe: "",
      ppeRemarks: "",
      techEquip: "",
      techEquipRemarks: "",
      vehicleEntryPass: "",
      companyCar: "",
      compAccomm: "",
      admSvRemarks: "",
      flat: "",
      flatRemarks: "",
      AttachmentslistArray: [],
    };
  }

  componentDidMount() {
    //this.getApproverList();
    this.setState({ loading: "Yes" });
    this.props.dispatch({ type: "headerTitle", value: "Approved : View" });
    this.geteDocRequest();
  }

  // getApproverList = () => {
  //   try {
  //     fetch(
  //       process.env.REACT_APP_WEB_SERVICE_URL +
  //         `/api/eDoc/GetApprovers?ReferenceNo=${this.state.referenceNo}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: "Bearer " + this.props.getToken,
  //         },
  //       }
  //     )
  //       .then((response) => {
  //         if (response.status === 200) {
  //           return response.json();
  //         } else if (response.status === 401) {
  //           this.props.dispatch({ type: "Referenceno", value: "" });
  //           this.props.dispatch({ type: "UserId", value: "" });
  //           this.props.dispatch({ type: "profile", value: "" });
  //           this.props.dispatch({ type: "headerTitle", value: "" });
  //           this.props.dispatch({ type: "Token", value: "" });
  //           this.props.dispatch({ type: "userType", value: "" });
  //           this.props.dispatch({ type: "userName", value: "" });
  //         }
  //       })
  //       .then((data) => {
  //         if (data) {
  //           for (const element of data.resultObject) {
  //             if (element.oriapproverid == this.props.UserId) {
  //               this.setState({
  //                 approverSection: element.section,
  //                 loading: "",
  //               });
  //             }
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         this.props.dispatch({ type: "Referenceno", value: "" });
  //         this.props.dispatch({ type: "UserId", value: "" });
  //         this.props.dispatch({ type: "profile", value: "" });
  //         this.props.dispatch({ type: "headerTitle", value: "" });
  //         this.props.dispatch({ type: "Token", value: "" });
  //         this.props.dispatch({ type: "userType", value: "" });
  //         this.props.dispatch({ type: "userName", value: "" });
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  GetAttachmentslistData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetApproverAttachments?ReferenceNo=${
            this.state.referenceNo
          }&UserId=${parseInt(this.props.UserId)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              AttachmentslistArray: data.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  geteDocRequest = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocDetails?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.resultObject) {
              this.setState({
                loading: "",
                referenceNo: data.resultObject.referenceNo,
                requesterId: data.resultObject.requesterId,
                typeOfExit: data.resultObject.typeOfExitName,
                typeOfExitName: data.resultObject.typeOfExitName,
                dateJoined: data.resultObject.dateJoined,
                lastDayofService: data.resultObject.lastDayofService,
                phoneNumber: data.resultObject.phoneNumber,
                address: data.resultObject.address,
                actionCategory: data.resultObject.actionCategory,
                companycode: data.resultObject.companycode,
                companyName: data.resultObject.companyName,
                divisionName: data.resultObject.divisionName,
                divisioncode: data.resultObject.divisioncode,
                actionType: data.resultObject.actionTypeName,
                employeeId: data.resultObject.employeeId,
                eDocType: data.resultObject.eDocType,
                employeeName: data.resultObject.employeeName,
                startDate: data.resultObject.startDate,
                endDate: data.resultObject.endDate,
                positionId: data.resultObject.positionId,
                salaryGrade: data.resultObject.salaryGrade,
                workingGroup: data.resultObject.workingGroup,
                additionalInformation: data.resultObject.additionalInformation,
                description: data.resultObject.description,
                userId: data.resultObject.userId,
                referenceLinkList: data.resultObject.referenceLinkList,
                attachmentList: data.resultObject.attachmentList,
                requesterName:
                  data.resultObject.requesterId +
                  " - " +
                  data.resultObject.requesterName,
                section: data.resultObject.section,
                department: data.resultObject.department,
                division: data.resultObject.division,
                designation: data.resultObject.designation,
                //HR Operations
                approverComments: data.resultObject.approverComments,
                noticePeriodtoServe: data.resultObject.noticePeriodtoServe,
                medicalCard: data.resultObject.medicalCard,
                hrRemarks: data.resultObject.hrRemarks,
                noticePeriodtoLieu: data.resultObject.noticePeriodtoLieu,
                annualLeaveBal: data.resultObject.annualLeaveBal,
                exitInterview: data.resultObject.exitInterview,
                ePass: data.resultObject.ePass,
                employmentPass: data.resultObject.employmentPass,
                empLastDayService: data.resultObject.lastDayofService
                  ? data.resultObject.lastDayofService.split("T")[0]
                  : data.resultObject.lastDayofService,
                //Central HR Services - Vehicle Loan
                motorVehicleLoan: data.resultObject.motorVehicleLoan,
                motorVehicleRemarks: data.resultObject.motorVehicleRemarks,
                //Respective Line Manager
                files: data.resultObject.files,
                documents: data.resultObject.documents,
                fixedAsset: data.resultObject.fixedAsset,
                cash: data.resultObject.cash,
                locker: data.resultObject.locker,
                keys: data.resultObject.keys,
                managerRemarks: data.resultObject.managerRemarks,
                //Central HR Services
                exceedMC: data.resultObject.exceedMC,
                exceedMedEnt: data.resultObject.exceedMedEnt,
                //Finance - Staff Advance
                staffAdvOutstand: data.resultObject.staffAdvOutstand,
                financeRemarks: data.resultObject.financeRemarks,
                //ICT - AD ID
                ictUserID: data.resultObject.ictUserID,
                ictUserIDRemarks: data.resultObject.ictUserIDRemarks,
                //ICT - Asset
                ictAsset: data.resultObject.ictAsset,
                ictAssetRemarks: data.resultObject.ictAssetRemarks,
                //COE- Training Bond
                trainingBond: data.resultObject.trainingBond,
                coEremarks: data.resultObject.coEremarks,
                //FAST - Admin Services (Vehicle)
                vehicleEntryPass: data.resultObject.vehicleEntryPass,
                companyCar: data.resultObject.companyCar,
                compAccomm: data.resultObject.compAccomm,
                admSvRemarks: data.resultObject.admSvRemarks,
                //FAST - Admin Services (MMHE Flat)
                flat: data.resultObject.flat,
                flatRemarks: data.resultObject.flatRemarks,
                //SCM - Tools
                techEquip: data.resultObject.techEquip,
                techEquipRemarks: data.resultObject.techEquipRemarks,
                //SCM - PPE (Warehouse)
                ppe: data.resultObject.ppe,
                ppeRemarks: data.resultObject.ppeRemarks,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
      this.GetAttachmentslistData();
    } catch (e) {
      console.log(e);
    }
  };

  handleFileDownload = async (url) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);
      this.setState({ file: fileUrl });
      this.openModal();
      return null;
    } catch (error) {
      console.error("Error downloading file:", error.message);
    }
  };

  downloadFile = (data, type) => {
    try {
      if (!data?.filePath && !data?.fileRecord) {
        toast.info("The specified file or path not found", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }
      const fileExtension = data.filename.split(".").pop().toLowerCase();
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Attachment/${
            data?.filePath
              ? `DownloadFromAzure?FilePath=${data?.filePath}`
              : `DownloadFile?SequenceNo=${data?.sequenceNo}`
          }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            if (type === "view") {
              if (
                [
                  "html",
                  "htm",
                  "pdf",
                  "txt",
                  "jpg",
                  "jpeg",
                  "png",
                  "gif",
                  "bmp",
                  "mp3",
                  "mp4",
                ].includes(fileExtension)
              ) {
                this.handleFileDownload(response.url);
                this.setState({ downloadData: data });
                return null;
              } else {
                toast.info("This file can only be downloaded", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                window.open(response.url, "_blank");
              }
            } else {
              return window.open(response.url, "_blank");
            }
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href={process.env.REACT_APP_ENV + "/mytask/approved/list"}>
              Approved : View
            </Breadcrumb.Item>
            <Breadcrumb.Item active>View</Breadcrumb.Item>
          </Breadcrumb>
          <div className="content-area">
            <section>
              <div style={{ margin: "auto", width: "0%" }}>
                <Spinner animation="border" variant="primary" />
              </div>
            </section>
          </div>
        </>
      );
    } else {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href={process.env.REACT_APP_ENV + "/mytask/approved/list"}>
              Approved : View
            </Breadcrumb.Item>
            <Breadcrumb.Item active>View</Breadcrumb.Item>
          </Breadcrumb>
          <div className="content-area">
            <section>
              <div className="form-group mb-2">
                <div className="approved-status">
                  <div className="">
                    <span className="mytask-approved-text">
                      Reference No.{" "}
                      <span className="d-none d-sm-inline"> :</span>
                    </span>{" "}
                    <span className="mytask-reference-text ">
                      {this.state.referenceNo}
                    </span>
                  </div>
                  <div className="">
                    <span className="mytask-approved-text">Status</span>{" "}
                    <div className="badge badge-mytask-approved">Approved</div>
                  </div>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <h2 className="form-heading">Requester Information</h2>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info  col-form-label">
                  {" "}
                  Staff No / Name{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.requesterName}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Section
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.section}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Department{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.department}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Division{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.division}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Designation{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.designation}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <h2 className="form-heading"> Requisition Details</h2>
              {this.state.eDocType?.includes("Employee Clearance") && (
                <div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      eDoc Type{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.eDocType}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Type of Exit{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.typeOfExitName}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Date of Joined{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.dateJoined && (
                                <Moment format="DD-MM-YYYY">
                                  {this.state.dateJoined}
                                </Moment>
                              )}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Last Day of Service{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              :{" "}
                            </span>
                            <span className="mytask-reference-text">
                              <Moment format="DD-MM-YYYY">
                                {this.state.lastDayofService}
                              </Moment>
                            </span>
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Phone Number{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.phoneNumber}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Address{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.address}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Description{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="d-flex align-items-baseline">
                        <p className="">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                          </>{" "}
                        </p>
                        <p
                          className="mytask-reference-text"
                          style={{ marginLeft: 5, marginTop: 9 }}
                          dangerouslySetInnerHTML={{
                            __html: this.state.description,
                          }}></p>
                      </div>
                    </div>
                    {/* <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.description}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Single" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Company Code
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.companyName}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Division Code{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.divisionName}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        EmployeeId / Name{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.employeeName}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Position ID{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.positionId}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Salary Grade{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.salaryGrade}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Working Group{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.workingGroup}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Addtional Information{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.additionalInformation}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Start Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.startDate && (
                                  <Moment format="DD-MM-YYYY">
                                    {this.state.startDate}
                                  </Moment>
                                )}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        End Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.endDate && (
                                  <Moment format="DD-MM-YYYY">
                                    {this.state.endDate}
                                  </Moment>
                                )}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Group" && (
                  <div>
                    <div className="form-group requester-info row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "None" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Others{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.additionalInformation}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType != "HRIS" &&
                !this.state.eDocType?.includes("Employee Clearance") && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                          style={{ marginLeft: -21, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
            </section>
            <section>
              <h2 className="form-heading"> Attachments </h2>
              <table className="table table-bordered overflow-auto-x">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> File Name </th>
                    {/* <th scope="col"> File Type </th> */}
                    <th scope="col"> Remarks </th>
                    <th scope="col"> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.attachmentList?.map((data, index) => (
                    <>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.filename}</td>
                        {/* <td>{data.filetype}</td> */}
                        <td>{data.remarks}</td>
                        <td>
                          <a
                            onClick={() => this.downloadFile(data, "view")}
                            target="_blank">
                            <img
                              className="action-right-space mouse-pointer"
                              src={
                                process.env.REACT_APP_ENV +
                                "/assets/images/icons/action/awesome-eye.svg"
                              }
                              alt="View"
                              data-tip="View"
                            />
                          </a>
                        </td>
                      </tr>
                      <Modal
                        show={this.state.isModalOpen}
                        onHide={this.closeModal}
                        size="xl">
                        <Modal.Header closeButton>
                          <Modal.Title>Attachment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {" "}
                          <div>
                            {this.state.file ? (
                              <iframe
                                src={this.state.file}
                                title="File Viewer"
                                width="100%"
                                height="500px"></iframe>
                            ) : (
                              <p>Loading...</p>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            onClick={() =>
                              this.downloadFile(this.state.downloadData)
                            }>
                            Download
                          </Button>
                          <Button variant="secondary" onClick={this.closeModal}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.attachmentList?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}
            </section>
            <section>
              <h2 className="form-heading"> References </h2>
              <table className="table table-bordered ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> Reference Link </th>
                    <th scope="col"> Remarks </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.referenceLinkList?.map((data, index) => (
                    <tr>
                      <td>{data.rowno}</td>
                      <td>
                        <u
                          style={{
                            color: "blue",
                            cursor: "pointer",
                          }}>
                          <a
                            onClick={() =>
                              data.reflink.includes("https")
                                ? window.open(data.reflink, "_blank")
                                : window.open(
                                    `https://${data.reflink}`,
                                    "_blank"
                                  )
                            }>
                            {data.reflink}
                          </a>
                        </u>
                      </td>
                      <td>{data.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.referenceLinkList?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}
            </section>
            <h2 className="form-heading"> Comments </h2>
            <table className="table table-bordered ">
              <div style={{ margin: "1rem" }}>
                <tbody>{this.state.approverComments}</tbody>
              </div>
            </table>
            {(this.state.approverSection == "HR Operation" ||
              this.state.approverSection == "HR (SU / MBU / BG1)" ||
              this.state.approverSection == "HR (HEO / BG2)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">HR Operation</h2>
                <div className="form-group row mb-0">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Employee Last day of Service
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.empLastDayService}
                        onChange={(e) =>
                          this.setState({ empLastDayService: e.target.value })
                        }
                        type="date"
                        disabled={true}
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Notice Period to Serve
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Days)
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.noticePeriodtoServe}
                        disabled={true}
                        min="0"
                        name="noticePeriodtoServe"
                        onChange={this.changeHandler}
                        type="number"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Notice Period in Lieu
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Days)
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.noticePeriodtoLieu}
                        disabled={true}
                        min="0"
                        name="noticePeriodtoLieu"
                        onChange={this.changeHandler}
                        type="number"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    1. Annual Leave Balance
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Days)
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.annualLeaveBal}
                        disabled={true}
                        name="annualLeaveBal"
                        onChange={this.changeHandler}
                        min="0"
                        type="number"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    2. Exit Interview
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ exitInterview: "Yes" })}
                        className="form-check-input"
                        type="radio"
                        checked={this.state.exitInterview == "Yes"}
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ exitInterview: "No" })}
                        checked={this.state.exitInterview == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ exitInterview: "NA" })}
                        checked={this.state.exitInterview == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    3. Employment Pass
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Only for Expatriate)
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ employmentPass: "Yes" })}
                        disabled={true}
                        checked={this.state.employmentPass == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ employmentPass: "No" })}
                        checked={this.state.employmentPass == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ employmentPass: "NA" })}
                        checked={this.state.employmentPass == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    4. E-Pass
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ePass: "Yes" })}
                        disabled={true}
                        checked={this.state.ePass == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ePass: "No" })}
                        disabled={true}
                        checked={this.state.ePass == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ePass: "NA" })}
                        disabled={true}
                        checked={this.state.ePass == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    5. Medical Card
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ medicalCard: "Yes" })}
                        disabled={true}
                        checked={this.state.medicalCard == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ medicalCard: "No" })}
                        disabled={true}
                        checked={this.state.medicalCard == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ medicalCard: "NA" })}
                        checked={this.state.medicalCard == "NA"}
                        disabled={true}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.hrRemarks}
                        disabled={true}
                        onChange={(e) =>
                          this.setState({ hrRemarks: e.target.value })
                        }
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {this.state.approverSection == "Respective Line Manager" && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Line Manager</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    1. Files
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ files: "Yes" })}
                        disabled={true}
                        checked={this.state.files == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ files: "No" })}
                        disabled={true}
                        checked={this.state.files == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ files: "NA" })}
                        disabled={true}
                        checked={this.state.files == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    2. Documents
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ documents: "Yes" })}
                        disabled={true}
                        checked={this.state.documents == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ documents: "No" })}
                        disabled={true}
                        checked={this.state.documents == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ documents: "NA" })}
                        disabled={true}
                        checked={this.state.documents == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    3. Fixed Assets
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ fixedAsset: "Yes" })}
                        checked={this.state.fixedAsset == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ fixedAsset: "No" })}
                        checked={this.state.fixedAsset == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ fixedAsset: "NA" })}
                        checked={this.state.fixedAsset == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    4. Cash
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ cash: "Yes" })}
                        checked={this.state.cash == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ cash: "No" })}
                        checked={this.state.cash == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ cash: "NA" })}
                        checked={this.state.cash == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    5. Locker
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ locker: "Yes" })}
                        checked={this.state.locker == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ locker: "No" })}
                        checked={this.state.locker == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ locker: "NA" })}
                        checked={this.state.locker == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    6. Keys
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ keys: "Yes" })}
                        checked={this.state.keys == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ keys: "No" })}
                        checked={this.state.keys == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ keys: "NA" })}
                        checked={this.state.keys == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.managerRemarks}
                        onChange={(e) =>
                          this.setState({ managerRemarks: e.target.value })
                        }
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {this.state.approverSection == "Central HR Services" && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Central HR Service</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Medical
                  </label>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Exceeded MC
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.exceedMC}
                        onChange={(e) =>
                          this.setState({ exceedMC: e.target.value })
                        }
                        min="0"
                        type="number"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Exceeded Medical entitlement
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.exceedMedEnt}
                        onChange={(e) =>
                          this.setState({ exceedMedEnt: e.target.value })
                        }
                        type="text"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection ==
              "Central HR Services - Vehicle Loan" ||
              this.state.approverSection ===
                "Central HR Services- Vehicle Loan") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Central HR Service</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Motor Vehicle Loan
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ motorVehicleLoan: "NA" })
                        }
                        disabled={true}
                        checked={this.state.motorVehicleLoan == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ motorVehicleLoan: "NA" })
                        }
                        disabled={true}
                        checked={this.state.motorVehicleLoan == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ motorVehicleLoan: "NA" })
                        }
                        disabled={true}
                        checked={this.state.motorVehicleLoan == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.motorVehicleRemarks}
                        onChange={(e) =>
                          this.setState({
                            motorVehicleRemarks: e.target.value,
                          })
                        }
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "Finance - Staff Advance" ||
              this.state.approverSection === "Finance- Staff Advance") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Finance</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Staff Advance (Outstanding)
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.staffAdvOutstand}
                        onChange={(e) =>
                          this.setState({ staffAdvOutstand: e.target.value })
                        }
                        type="text"
                        placeholder="RM"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.financeRemarks}
                        type="textarea"
                        placeholder="Specify item and Amount"
                        onChange={(e) =>
                          this.setState({ financeRemarks: e.target.value })
                        }
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "ICT - AD ID" ||
              this.state.approverSection === "ICT- AD ID") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">ICT</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    User ID
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ ictUserID: "Yes" })}
                        checked={this.state.ictUserID == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ ictUserID: "No" })}
                        checked={this.state.ictUserID == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ ictUserID: "NA" })}
                        checked={this.state.ictUserID == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.ictUserIDRemarks}
                        type="textarea"
                        placeholder="Specify item and Amount"
                        onChange={(e) =>
                          this.setState({ ictUserIDRemarks: e.target.value })
                        }
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "ICT - Asset" ||
              this.state.approverSection === "ICT- Asset") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">ICT</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    ICT Assets
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ ictAsset: "Yes" })}
                        checked={this.state.ictAsset == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ ictAsset: "No" })}
                        checked={this.state.ictAsset == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ ictAsset: "NA" })}
                        checked={this.state.ictAsset == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        value={this.state.ictAssetRemarks}
                        onChange={(e) =>
                          this.setState({ ictAssetRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "Training Center" ||
              this.state.approverSection === "COE- Training Bond") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Training Centre</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Training Bond
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ trainingBond: "Yes" })}
                        checked={this.state.trainingBond == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ trainingBond: "No" })}
                        checked={this.state.trainingBond == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ trainingBond: "NA" })}
                        checked={this.state.trainingBond == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.coEremarks}
                        onChange={(e) =>
                          this.setState({ coEremarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "FAST - Admin Services (Vehicle)" ||
              this.state.approverSection ===
                "FAS- Admin Services (Vehicle Pass)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Admin Services</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    1. Vehicle Entry Pass
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() =>
                          this.setState({ vehicleEntryPass: "Yes" })
                        }
                        checked={this.state.vehicleEntryPass == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() =>
                          this.setState({ vehicleEntryPass: "No" })
                        }
                        checked={this.state.vehicleEntryPass == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() =>
                          this.setState({ vehicleEntryPass: "NA" })
                        }
                        checked={this.state.vehicleEntryPass == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    2. Company Car
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ companyCar: "Yes" })}
                        checked={this.state.companyCar == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ companyCar: "No" })}
                        checked={this.state.companyCar == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ companyCar: "NA" })}
                        checked={this.state.companyCar == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    3. Company's Accomodation
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ compAccomm: "Yes" })}
                        checked={this.state.compAccomm == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ compAccomm: "No" })}
                        checked={this.state.compAccomm == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ compAccomm: "NA" })}
                        checked={this.state.compAccomm == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.admSvRemarks}
                        onChange={(e) =>
                          this.setState({ admSvRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection ==
              "FAST - Admin Services (MMHE Flat)" ||
              this.state.approverSection ===
                "FAS- Admin Services (MMHE Flat)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Admin Services</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Flat
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ flat: "Yes" })}
                        checked={this.state.flat == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ flat: "No" })}
                        checked={this.state.flat == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        disabled={true}
                        onClick={() => this.setState({ flat: "NA" })}
                        checked={this.state.flat == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.flatRemarks}
                        onChange={(e) =>
                          this.setState({ flatRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "SCM - Tools" ||
              this.state.approverSection == "SCM- Tools") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Supply Chain Management</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Technical Equipment
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.techEquip}
                        onChange={(e) =>
                          this.setState({ techEquip: e.target.value })
                        }
                        type="text"
                        placeholder="unit(s)"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.techEquipRemarks}
                        onChange={(e) =>
                          this.setState({ techEquipRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "SCM - PPE (Warehouse)" ||
              this.state.approverSection === "SCM- PPE (Warehouse)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Supply Chain Management</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Personal protective Equipment <br />
                    (PPE)
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.ppe}
                        onChange={(e) => this.setState({ ppe: e.target.value })}
                        type="text"
                        placeholder="unit(s)"
                      />
                    </FormGroup>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        disabled={true}
                        value={this.state.ppeRemarks}
                        onChange={(e) =>
                          this.setState({ ppeRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            <section>
              <h2 className="form-heading">Approver Attachments </h2>
              <table className="table table-bordered overflow-auto-x">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> File Name </th>
                    {/* <th scope="col"> File Type </th> */}
                    <th scope="col"> Remarks </th>
                    <th scope="col"> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.AttachmentslistArray?.map((data, index) => (
                    <>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.filename}</td>
                        {/* <td>{data.filetype}</td> */}
                        <td>{data.remarks}</td>
                        <td>
                          <a
                            onClick={() => this.downloadFile(data, "view")}
                            target="_blank">
                            <img
                              className="action-right-space mouse-pointer"
                              src={
                                process.env.REACT_APP_ENV +
                                "/assets/images/icons/action/awesome-eye.svg"
                              }
                              alt="View"
                              data-tip="View"
                            />
                          </a>
                        </td>
                      </tr>
                      <Modal
                        show={this.state.isModalOpen}
                        onHide={this.closeModal}
                        size="xl">
                        <Modal.Header closeButton>
                          <Modal.Title>Attachment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {" "}
                          <div>
                            {this.state.file ? (
                              <iframe
                                src={this.state.file}
                                title="File Viewer"
                                width="100%"
                                height="500px"></iframe>
                            ) : (
                              <p>Loading...</p>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            onClick={() =>
                              this.downloadFile(this.state.downloadData)
                            }>
                            Download
                          </Button>
                          <Button variant="secondary" onClick={this.closeModal}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.AttachmentslistArray?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}
            </section>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(approvedView);
